import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

type UseQuote = [TrpcOutputs['getQuote'] | undefined, boolean, string | undefined];

export const useQuote = (quoteId: number): UseQuote => {
  const initQuery = trpc.getQuote.useQuery({ id: quoteId });
  const [error, setError] = useState<string>();
  const [data, setData] = useState<TrpcOutputs['getQuote'] | undefined>();

  useEffect(() => {
    setData(undefined);
    setError(undefined);
  }, [quoteId]);

  useEffect(() => {
    if (initQuery.data) setData(initQuery.data);
  }, [initQuery.data]);

  useEffect(() => {
    if (initQuery.error) setError(initQuery.error.message);
  }, [initQuery.error]);

  // Subscriptions are request-scoped; only apply events for this hook's quoteId (see useQuotes).
  trpc.onQuoteCreated.useSubscription({ requestId: data?.request_id } as any, {
    onData: (newData: any) => {
      if (newData?.id === quoteId) setData(newData);
    },
    onError: (err: any) => {
      console.log('onQuoteCreated error: ', err);
      setError(err?.message);
    },
  });

  trpc.onQuoteUpdated.useSubscription({ requestId: data?.request_id } as any, {
    onData: (newData: any) => {
      if (newData?.id === quoteId) setData(newData);
    },
    onError: (err: any) => {
      console.log('onQuoteUpdated error: ', err);
      setError(err?.message);
    },
  });

  trpc.onQuoteDeleted.useSubscription({ requestId: data?.request_id } as any, {
    onData: (deletedQuoteId: number) => {
      if (deletedQuoteId === quoteId) setData(null);
    },
    onError: (err: any) => {
      console.log('onQuoteDeleted error: ', err);
      setError(err?.message);
    },
  });

  const isLoading = Boolean(initQuery.isLoading);
  return [data, isLoading, error];
};
